import React, { useState, useEffect } from "react";
import styled from "styled-components";
import IUMRSNavBar from "./IUMRSNavbar.jsx";
import { ICAMNavroute } from '../../../utils/ICAMnavroute.js';
import IUMRSFooter from "./IUMRSFooter";
import MainForm from "../../icamregistration/MainForm.jsx";
import SuccessRedirect from "../../icamregistration/SuccessRedirect.jsx";
import axios from "axios";
import banner from "../../../assets/images/conference_banner.jpg"

const BackendUrl = "https://amrs-prod.eu-north-1.elasticbeanstalk.com";

const IUMRSRegistration = () => {
    const [formData, setFormData] = useState({
        registration_category: "student",
        is_workshop: false,
        firstname: "", 
        surname: "", 
        contact: "", 
        email: "",
        location: "",
        affiliation: "",
        affiliation_address_street: "",
        affiliation_address_city: "",
        affiliation_address_country: "",
        abstract_required: false,
        presentational_mode: "in-attendance",
        symposium_type: "advanced_energy_materials",
        registration_timeframe: "regular",
        banquet: false,
        excursion: false,
    });
    
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submissionError, setSubmissionError] = useState("");
    const [submissionSuccess, setSubmissionSuccess] = useState(false);
    const [paymentEmail, setPaymentEmail] = useState("");
    const [hasAbstract, setHasAbstract] = useState(false);


    useEffect(() => {
        setHasAbstract(!!formData.abstract);
    }, [formData.abstract]);

    const handleChange = (e) => {
        const { name, value, type, checked, files, multiple } = e.target;
        
        setFormData((prevFormData) => {
            let updatedFormData = { ...prevFormData };
    
            if (type === 'file') {
                updatedFormData[name] = files[0];
            } else if (type === 'checkbox') {
                updatedFormData[name] = checked;
    
                if (name === 'is_workshop' && !checked) {
                    delete updatedFormData.workshop_category;
                }
            } else if (multiple) {
                const selected = Array.from(e.target.selectedOptions, option => option.value);
                updatedFormData[name] = selected;
            } else {
                updatedFormData[name] = value;
            }
    
            return updatedFormData;
        });
    };

    const handleDeleteAbstract = () => {
        setFormData(prevFormData => {
            const newFormData = { ...prevFormData };
            delete newFormData.abstract;
            return newFormData;
        });
        
        if (formData.abstract_object_etag || formData.abstract_object_key) {
            setFormData(prevFormData => ({
                ...prevFormData,
                abstract_object_etag: null,
                abstract_object_key: null,
                abstract_required: false
            }));
        }
    };

    const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmissionError("");
    setSubmissionSuccess(false);
    
    if (formData.email !== formData.confirmEmail) {
        setSubmissionError("Emails do not match!");
        setIsSubmitting(false);
        return;
    }
    
    try {
    const { confirmEmail, ...dataToSubmit } = formData;
    const { abstract, ...registrationData } = dataToSubmit;
    
    const fileFormData = new FormData();
    
    fileFormData.append("registration_data", JSON.stringify({...registrationData}));

    if (abstract && abstract instanceof File) {
        fileFormData.append('abstract', abstract);
    }
        
    const registrationResponse = await axios.post(
        `${BackendUrl}/event/conference/iumrs-icam2025/register`,
        fileFormData,
        {
            headers: { 'Accept': '*/*'},
            timeout: 20000
        }
    );

    setSubmissionSuccess(true);
    
    // ... success handling

    } catch (err) {
        
        if (err.response) {
            
            let errorMessage = "Registration failed";
            
            if (err.response.data.detail) {
                // Handle Pydantic validation errors
                if (Array.isArray(err.response.data.detail)) {
                    const errors = err.response.data.detail.map(error => 
                        `${error.loc?.join('.')}: ${error.msg}`
                    ).join('; ');
                    errorMessage = `Validation errors: ${errors}`;
                } else {
                    errorMessage = err.response.data.detail;
                }
            } else if (err.response.data.message) {
                errorMessage = err.response.data.message;
            }
            
            setSubmissionError("Missing Field");
        } else if (err.request) {
            setSubmissionError("Network error. Please check your connection and try again.");
        } else {
            setSubmissionError(`Error: ${err.message}`);
        }
    } finally {
        setIsSubmitting(false);
    }
};
    
    const storeReference = (reference) => {
        localStorage.setItem('amrsghana_payRef', reference);
    };
    
    const routetoPayment = async (e, paymentEmail) => {
        try {
            if (paymentEmail) {
                const PayInitializationResponse = await axios.post(
                    `${BackendUrl}/event/conference/iumrs-icam2025/payment-request`,
                    { email: paymentEmail},
                    {
                        headers: {'Accept': 'application/json','Content-Type': 'application/json',},
                    }
                );
                
                const { payment_url, reference } = PayInitializationResponse.data;
                storeReference(reference);
                
                window.location.href = payment_url;
            }
        } catch (err) {
            if (err.response && err.response.status === 301) {
                const { payment_url, reference } = err.response.data;
                storeReference(reference);
                window.location.href = payment_url;
            } else {
                // Handle all other errors
                setSubmissionError("Error with initializing payment")
            }
        }
    };
    
    
    return (
        <Container>
            <IUMRSNavBar navroute={ICAMNavroute}/>
            <Banner>
                <img src={banner}/>
            </Banner>
            {submissionError && (
                <div className="error-notifier">
                    {submissionError}
                </div>
            )}
            <div className="main-section">
                <div className="registration-field">
                    {submissionSuccess ? (
                        <SuccessRedirect 
                            routetoPayment={routetoPayment}
                            paymentEmail={formData.email}
                        />
                    ) : (
                        <MainForm
                            formData={formData}
                            setFormData={setFormData}
                            handleChange={handleChange}
                            handleSubmit={handleSubmit}
                            isSubmitting={isSubmitting}
                            hasAbstract={hasAbstract}
                            handleDeleteAbstract={handleDeleteAbstract}
                        />
                    )}
                </div>
            </div>
            <IUMRSFooter/>
        </Container>
    );
};

const Banner = styled.div`
    width: 100%;
    height: 1.8rem;

    img{
        width: 100%
    }

    @media only screen and (min-width: 768px){
        height: 10rem;
    }
` 
const Container = styled.div`
    background-color: #f4f6f9;
    min-height: 100vh;
    
    .error-notifier{
        padding: 1rem;
        background-color: #FA113D;
        color: white;
        font-size: 1rem;
        transition: all .5s ease;
    }

    .main-section {
        margin: 6em 0;
        display: flex;
        justify-content: center;
        padding-bottom: 3em;
    }

    .registration-field {
        width: 100%;
        max-width: 700px;
        padding: 2.5em;
        background: white;
        border-radius: 12px;
        box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1);
    }
    
    @media only screen and (max-width: 768px) {
        .registration-field {
            padding: 1.5em;
            margin: 0 1em;
            max-width: 100%;
        }
    }
`;



export default IUMRSRegistration;